<template>
  <v-app>
    <v-app-bar app color="blue-grey lighten-5">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="$vuetify.breakpoint.smAndDown"></v-app-bar-nav-icon>

      <template v-if="!isHiddenMode || (isHiddenMode && $route.name && $route.name.includes('home'))">
        <v-toolbar-items class="mx-3" v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn v-for="(item, index) in items" :key="item.title" text tile small link :to="item.link" exact>
            <v-icon>{{ item.icon }}</v-icon>
            <span class="mx-1">{{ $vuetify.lang.t(item.title) }}</span>
          </v-btn>
        </v-toolbar-items>
      </template>

      <v-spacer></v-spacer>
      <profile-button class="mx-5"></profile-button>
      <localization-switcher></localization-switcher>
    </v-app-bar>

    <message-snackbar></message-snackbar>

    <!-- will be used only on mobiles or very small screens -->
    <template v-if="!isHiddenMode || (isHiddenMode && $route.name && $route.name.includes('home'))">
      <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary>
        <v-list
          nav
          dense>
          <v-list-item v-for="(item, index) in items" :key="item.title" :to="item.link">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <span>{{ $vuetify.lang.t(item.title) }}</span>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
    </template>

    <v-content :class="{background_color: hasBackground}">
      <!--      <v-container fluid>-->
      <div class="slider">
        <v-slide-x-transition :hide-on-leave="true" :leave-absolute="true">
          <router-view/>
        </v-slide-x-transition>
      </div>

      <div v-if="!isPrerendered">
        <v-bottom-sheet v-model="userPolicy" :inset="$vuetify.breakpoint.mdAndUp" v-if="!isPolicyAccepted">
          <v-card tile>
            <v-card-title class="mb-0">
              <v-icon left class="mr-5">{{ coockieIcon }}</v-icon>
              <span :class="{'subtitle-2': $vuetify.breakpoint.xsOnly}">{{
                  $vuetify.lang.t('$vuetify.policyAlert.title')
                }}</span>
              <v-spacer></v-spacer>
              <v-btn icon class="text-right" @click="userPolicy = !userPolicy">
                <v-icon>{{ closeIcon }}</v-icon>
              </v-btn>
            </v-card-title>
            <div class="subtitle-1 black--text px-6">
              <div :class="{'policyMobile': $vuetify.breakpoint.xsOnly}"
                   v-html="$vuetify.lang.t('$vuetify.policyAlert.description', [$router.resolve({'name': 'legalInformation'}).href])"></div>
            </div>
            <v-card-actions class="justify-center">
              <template v-if="$vuetify.breakpoint.smAndUp">
                <v-spacer></v-spacer>
                <v-btn class="mx-5" color="orange" width="150" @click="acceptSiteUsage">{{
                    $vuetify.lang.t('$vuetify.policyAlert.acceptButton')
                  }}
                </v-btn>
              </template>
              <template v-else>
                <div>
                  <v-btn class="mx-5 text-center align-content-center" color="orange" width="250"
                         @click="acceptSiteUsage">{{
                      $vuetify.lang.t('$vuetify.policyAlert.acceptButton')
                    }}
                  </v-btn>
                </div>
              </template>
            </v-card-actions>
          </v-card>

        </v-bottom-sheet>
      </div>

    </v-content>
  </v-app>
</template>

<script>
import {
  mdiOpenInNew,
  mdiHome,
  mdiStar,
  mdiTestTube,
  mdiBook,
  mdiLightbulbOn,
  mdiClose,
  mdiCookie, mdiCertificate
} from '@mdi/js'
import LocalizationSwitcher from './components/utils/localizationSwitcher'
import MessageSnackbar from './components/utils/messageSnackbar'
import profileButton from './components/map/profileButton'

import { AUTH_MODULE, SETTINGS_MODULE } from './store/modules'
import { createNamespacedHelpers } from 'vuex'

import { createHelpers } from 'vuex-map-fields'
import { LANDING_MODULE } from '@/store/modules'
import { isPrerendered } from './utils/prerender'

const { mapState } = createNamespacedHelpers(AUTH_MODULE)

const { mapFields } = createHelpers({
  getterType: `${LANDING_MODULE}/getField`,
  mutationType: `${LANDING_MODULE}/updateField`
})

const { mapFields: settingsFields } = createHelpers({
  getterType: `${SETTINGS_MODULE}/getField`,
  mutationType: `${SETTINGS_MODULE}/updateField`
})

export default {
  name: 'App',
  components: { profileButton, MessageSnackbar, LocalizationSwitcher },
  data: () => ({
    drawer: false,
    userPolicy: true, // default value

    mdiOpenInNew: mdiOpenInNew,
    mdiHome: mdiHome,
    mdiStar: mdiStar,
    mdiTestTube: mdiTestTube,
    mdiBook: mdiBook,
    mdiLightbulbOn: mdiLightbulbOn,
    closeIcon: mdiClose,
    coockieIcon: mdiCookie,

    items: [
      { icon: mdiHome, title: '$vuetify.navbar.main', link: { name: 'home' } },
      { icon: mdiStar, title: '$vuetify.navbar.features', link: { name: 'home.functionality' } },
      { icon: mdiTestTube, title: '$vuetify.navbar.papers', link: { name: 'home.papers' } },
      { icon: mdiBook, title: '$vuetify.navbar.press', link: { name: 'home.press' } },
      { icon: mdiLightbulbOn, title: '$vuetify.navbar.patents', link: { name: 'home.patents' } },
      { icon: mdiCertificate, title: '$vuetify.navbar.diplomas', link: { name: 'home.diplomas' } }
    ]
  }),
  computed: {
    ...mapState(['auth']),
    ...mapFields(['slide']),
    ...settingsFields(['isPolicyAccepted']),
    isMobile () {
      return this.$vuetify.breakpoint.xs
    },
    hasBackground () {
      return 'meta' in this.$route && 'background' in this.$route.meta && this.$route.meta.background
    },
    isPrerendered () {
      return isPrerendered()
    },
    isHiddenMode () {
      return Boolean(process.env.VUE_APP_HIDDEN_MODE) === true
    }
  },
  methods: {
    changeSlide (index) {
      this.slide = index
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' })
      }
    },
    acceptSiteUsage () {
      this.isPolicyAccepted = true
      this.userPolicy = false
    }
  },
  watch: {
    slide () {
      this.drawer = false
    }
  },
  mounted () {
    this.userPolicy = !this.isPolicyAccepted
  },

}
</script>

<style>
.pointer {
  cursor: pointer;
}

.link {
  color: grey;
}

.slider > .slide-x-transition-enter-active,
.slider > .slide-x-transition-leave-active {
  transition-duration: .5s
}

.background_color {
  background: linear-gradient(150deg, #ffe7e0 40%, #e0e9ff 60%);
}

.policyMobile {
  line-height: 1.45rem
}

</style>
